import { FC } from "react";
import { useTranslation } from "react-i18next";
import { MainSearch } from "src/Modules/Flights/Components";

interface JourneySearchWebProps {
  imgUrl?: string;
}

const JourneySearchWeb: FC<JourneySearchWebProps> = ({ imgUrl }) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-col items-center px-2 px-2 pt-2">
      <div className="relative w-full max-w-[97%]">
        <div
          className="relative h-[360px] w-full overflow-hidden rounded-2xl bg-cover bg-center lg:h-[480px]"
          style={{ backgroundImage: `url(${imgUrl})`, backgroundPosition: "0 60%" }}
        >
          <div className="absolute inset-0 bg-linear-to-t from-transparent via-background-overlay/40 background-overlay/60" />
          <div className="relative z-10 flex h-full flex-col justify-center gap-2 px-8 lg:px-12">
            <h1 className="text-start text-2xl font-bold text-font-inverted lg:text-4xl">{t("Flights.search.heroTitle")}</h1>
            <p className="text-start text-base text-font-inverted lg:text-xl">{t("Flights.search.heroSubtitle")}</p>
          </div>
        </div>

        <div className="-mt-35 relative z-20 rounded-xl bg-background-default p-5 shadow-xl lg:mx-8 lg:p-7">
          <MainSearch />
        </div>
      </div>
    </div>
  );
};

export default JourneySearchWeb;
